import React, { useEffect, useState } from "react";

import { Trans } from "react-i18next";
import i18next from "i18next";
import i18n from "../../../i18n";

import {
  Classes,
  Tag,
  Callout,
  Button,
  Dialog,
  Spinner,
  Icon,
  Popover,
  Card,
  HTMLTable,
} from "@blueprintjs/core";

import {
  authenticatedGetFetch,
  authenticatedPutFetch,
  authenticatedPostFetch,
} from "../../../utils/AuthenticatedFetch";

import { EquipmentSelect } from "../../Structure/EquipmentSelector";
import {
  mefMontantStr,
  mefDate,
  mefPlate,
  userIcons,
  mefMontant,
} from "../../../utils/mef";
import { getSetting } from "../../Settings/InstallationSettings";
import PlateImage from "../ALPR/PlateImage";

function DuplicataButton(props) {
  const [duplicate, setDuplicate] = useState(undefined);
  const [target, setTarget] = useState(0);
  return (
    <span>
      <Button
        icon="duplicate"
        onClick={() =>
          setDuplicate({
            server: props.server,
            equipment: props.entryEquipment,
            date: props.entryDate,
          })
        }
      >
        <Trans>generate duplicata</Trans>
      </Button>
      <Dialog
        title={<Trans>generate duplicata</Trans>}
        isOpen={duplicate !== undefined}
        cancelButtonText={i18n.t("cancel")}
        onClose={() => setDuplicate()}
        onCancel={() => setDuplicate()}
        canEscapeKeyCancel={true}
        canOutsideClickCancel={true}
        intent="warning"
        icon="duplicate"
      >
        <div className={Classes.DIALOG_BODY}>
          <div className="flexbox-left">
            <Trans>generate on equipment</Trans>
            <EquipmentSelect
              filter="exception"
              onSelect={(id) => setTarget(id)}
            />
            <Callout intent="primary">
              <Trans>
                this action will be registered and visible by the administrator
              </Trans>
            </Callout>
          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button
                intent="primary"
                text={i18n.t("generate duplicata")}
                onClick={() => {
                  authenticatedPostFetch("/duplicate", {
                    srv: duplicate.server,
                    targetEquipment: target,
                    entryEquipment: duplicate.equipment,
                    entryDate: duplicate.date,
                  });
                }}
                disabled={target === 0}
              />
            </div>
          </div>
        </div>
      </Dialog>
    </span>
  );
}

function ExternalPaymentButton(ticket) {
  const [duplicate, setDuplicate] = useState(undefined);
  const [amount, setAmount] = useState(undefined);
  const [dls, setDls] = useState(undefined);

  //{"NUMEROTA":"20231218131325","EQUIENTR":194,"TKETAT":"Q","TKPARC":1,"TKIMMAT":"","TKIDRMQ":"","TKIDSUP":"","TKMONT":null,"TKNBR":null,"TKMTPAYE":1800,"TKDATLMS":"20231218141852","TKDATDPA":"20231218141352","TKDUREC":null,"TKDATENT":"","id":"19420231218131325","events":[{"ID":687,"DATEINSERT":"2023-12-19T09:03:54.123Z","PROCESSED":true,"parking_processed":false,"DAYEVEN":"2023-12-18T13:14:03.000Z","syncServerId":1,"DATEEVEN":"20231218141403","NUMEPARC":1,"NUMEEQUI":105,"IMMAT":"","DATEENTR":"20231218131325","EQUIENTR":194,"MONTSTAT":900,"DURESTAT":60,"MODEPAIE":2,"CODESUP":"V","INFOSUP":"C53208","TYPEUS":0,"IDENUS":"0194231218131325","TYPECB":"c","CATEUSAG":1,"NUMEPROF":70,"IDENTIF":"***************1544","CODEMON":3,"subscriberId":null,"ticketId":"194231218131325","ccId":null,"event":{"id":40,"display":true,"intent":"success"}}]}

  useEffect(() => {
    if (
      getSetting("display external ticket payment button", false) &&
      ticket.NUMEROTA
    )
      authenticatedGetFetch(
        "/tarif/calculate?" +
          new URLSearchParams({
            srv: ticket.server,
            tarif: ticket.tarif,
            entry: ticket.TKDATLMS || ticket.NUMEROTA,
          }),
        async (res) => {
          setAmount(res["amount"]);
          setDls(res["limit_exit_date"]);
        }
      );
  }, [ticket.NUMEROTA, ticket.server, ticket.TKDATLMS, ticket.tarif]);

  if (getSetting("display external ticket payment button", false))
    return (
      <span>
        <Popover
          placement="auto"
          interactionKind="hover"
          content={
            <Card>
              <Trans>ticket already paid</Trans>
            </Card>
          }
          disabled={amount !== undefined && amount !== 0}
        >
          <Button
            icon="euro"
            onClick={() =>
              setDuplicate({
                server: ticket.server,
                equipment: ticket.entryEquipment,
                date: ticket.entryDate,
              })
            }
            loading={amount === undefined}
            disabled={amount === 0}
          >
            <Trans>external payment</Trans>
          </Button>
        </Popover>
        <Dialog
          title={<Trans>external payment</Trans>}
          isOpen={duplicate !== undefined}
          cancelButtonText={i18n.t("cancel")}
          onClose={() => setDuplicate()}
          onCancel={() => setDuplicate()}
          canEscapeKeyCancel={true}
          canOutsideClickCancel={true}
          intent="warning"
          icon="euro"
        >
          <div className={Classes.DIALOG_BODY}>
            <Callout intent="danger">
              <Trans>
                this action will be registered and visible by the administrator
              </Trans>{" "}
              <Trans>
                payment will be registered in financial report as an external
                payment
              </Trans>
            </Callout>

            <table>
              <tr>
                <td>
                  <Trans>amount to pay:</Trans>
                </td>
                <td>
                  <Tag>{mefMontantStr(amount)}</Tag>
                </td>
              </tr>
              <tr>
                <td>
                  <Trans>dls:</Trans>
                </td>
                <td>
                  <Tag>{mefDate(dls)}</Tag>
                </td>
              </tr>
            </table>
            <div className={Classes.DIALOG_FOOTER}>
              <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                <Button
                  intent="primary"
                  text={i18n.t("pay the ticket")}
                  onClick={() => {
                    authenticatedPostFetch(
                      "/ticket/payment",
                      {
                        srv: ticket.server,
                        entryDevice: ticket.EQUIENTR,
                        entryDate: ticket.NUMEROTA,
                        limitExitDate: dls,
                        paidAmount: amount,
                      },
                      () => {
                        // close popover
                        ticket.update(new Date());
                        setDuplicate();
                      }
                    );
                  }}
                  disabled={amount === undefined}
                />
              </div>
            </div>
          </div>
        </Dialog>
      </span>
    );
  else return null;
}

function TicketAction(props) {
  return (
    <Button
      icon={props.icon}
      text={props.text}
      onClick={() => {
        authenticatedPutFetch(
          "/ticket/" + props.id + "?srv=" + props.server,
          props.action,
          () => {
            props.update(); //This call generate the ticket get information request
          }
        );
      }}
    />
  );
}

function ticketState(state) {
  switch (state) {
    case "P":
    case "p": // pedestrian
      return (
        <Tag intent="success">
          <Trans>present</Trans>
        </Tag>
      );
    case "Q":
    case "q": // pedestrian
      return (
        <Tag intent="success">
          <Trans>present paid</Trans>
        </Tag>
      );
    case "A":
      return (
        <Tag intent="danger">
          <Trans>alarme</Trans>
        </Tag>
      );
    case "S":
      return (
        <Tag intent="warning">
          <Trans>finished</Trans>
        </Tag>
      );
    case "E":
      return (
        <Tag intent="warning">
          <Trans>expired</Trans>
        </Tag>
      );
    case "U":
    default:
      return (
        <Tag>
          <Trans>unknown</Trans>
        </Tag>
      );
  }
}

export function TicketManagement(props) {
  const [waiting, wait] = useState(true);
  const [ticket, setTicket] = useState({});
  const [_update, update] = useState(undefined);

  useEffect(() => {
    if (props.id)
      authenticatedGetFetch(
        "/ticket/" + props.id + "?srv=" + props.server,
        (response) => {
          setTicket(response);
          wait(false);
        },
        null,
        null,
        () => {
          setTicket({});
          wait(false);
        }
      );
  }, [props.id, props.server, _update]);

  /* if (true)
    return <div>{JSON.stringify(props)}</div>
  else  */
  if (props.isOpen === undefined || props.isOpen === true)
    return (
      <Dialog
        hasBackdrop={true}
        isOpen={
          props.isOpen !== undefined ? props.isOpen : props.id !== undefined
        }
        canEscapeKeyCancel={true}
        canOutsideClickCancel={true}
        intent="primary"
        icon={userIcons[0]}
        title={
          <span>
            <Trans>userType0</Trans> <b>n°{props.id}</b>
          </span>
        }
        onClose={() => {
          if (props.onClose) props.onClose();
        }}
        onCancel={() => {
          if (props.onClose) props.onClose();
        }}
      >
        {waiting ? (
          <Spinner />
        ) : ticket.id === undefined ? (
          <Callout
            key={"img"}
            intent="warning"
            title={
              <span>
                <Trans>userType0</Trans> <Trans>not found on the server</Trans>
              </span>
            }
          >
            <p>
              <Trans>can't retreive data</Trans>
            </p>
            <p>
              <Trans>
                the ticket could be purged according to the server settings
              </Trans>
            </p>
            <div className="flexbox-center">
              <Icon icon="unknown-vehicle" size="100" />
            </div>
          </Callout>
        ) : (
          <>
            <Callout
              key={"img"}
              intent="primary"
              title={
                <span>
                  <Trans>userType0</Trans>
                </span>
              }
            >
              <ul>
                {ticket.TKETAT && (
                  <li>
                    <Trans>parking state:</Trans>
                    {ticketState(ticket.TKETAT)}
                  </li>
                )}
                {ticket.TKPARC && (
                  <li>
                    <Trans>park:</Trans>
                    {props.parkLookup[ticket.TKPARC]}
                  </li>
                )}
                {ticket.EQUIENTR && (
                  <li>
                    <Trans>entry device</Trans> :{" "}
                    {props.deviceLookup[props.server + "_" + ticket.EQUIENTR]}
                  </li>
                )}
                {ticket.NUMEROTA && (
                  <li>
                    <Trans>entry date:</Trans>
                    {mefDate(ticket.NUMEROTA)}
                  </li>
                )}
                {ticket.TKMTPAYE && (
                  <li>
                    {i18n.t("paid amount") + i18n.t(":")}
                    {mefMontantStr(ticket.TKMTPAYE)}
                  </li>
                )}
                {ticket.TKIMMAT && (
                  <li>
                    <Trans>associated license plate:</Trans>
                    <Tag icon="blank" className="licenseplate-little">
                      {mefPlate(ticket.TKIMMAT)}
                    </Tag>
                  </li>
                )}
              </ul>

              {(props.hideAction === undefined ||
                props.hideAction === false) && (
                <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                  {/* if present or present or paid */}
                  {(ticket.TKETAT === "P" || ticket.TKETAT === "Q") && (
                    <>
                      <DuplicataButton
                        key="dup"
                        entryEquipment={ticket.EQUIENTR}
                        entryDate={ticket.NUMEROTA}
                        contract={ticket.contract}
                        server={props.server}
                      />
                      <ExternalPaymentButton
                        key="extp"
                        {...ticket}
                        update={() => {
                          update(new Date());
                        }}
                        refresh={_update}
                        server={props.server}
                      />
                    </>
                  )}

                  {/* if flagged alarm */}
                  {ticket.TKETAT === "A" && (
                    <TicketAction
                      key="ral"
                      id={ticket.id}
                      action={{ presence: true }}
                      icon="follower"
                      text={i18n.t("make the ticket valid")}
                      server={props.server}
                      update={() => {
                        update(new Date());
                      }}
                    />
                  )}

                  {/* if present not flagged alarm */}
                  {(ticket.TKETAT === "P" || ticket.TKETAT === "Q") && (
                    <TicketAction
                      key="sal"
                      id={ticket.id}
                      action={{ alarme: true }}
                      icon="blocked-person"
                      text={i18n.t("invalidate ticket")}
                      server={props.server}
                      update={() => {
                        update(new Date());
                      }}
                    />
                  )}
                </div>
              )}
            </Callout>

            {ticket.events && ticket.events.length > 0 && (
              <Callout title={<Trans>event history</Trans>} icon="history">
                <HTMLTable striped={true} compact={true}>
                  <tbody>
                    {ticket.events.map((event) => (
                      <tr key={event.ID}>
                        <td>
                          {new Date(event.DAYEVEN).toLocaleString(
                            i18next.language
                          )}
                        </td>
                        <td>
                          {event.event !== undefined &&
                            event.event !== null && (
                              <Tag intent={event.event.intent}>
                                <Trans>{"event" + event.event.id}</Trans>
                              </Tag>
                            )}
                          {event.IMMAT && (
                            <>
                              <br />
                              <PlateImage
                                key="imm"
                                park={event.NUMEPARC}
                                plate={event.IMMAT}
                                date={event.DAYEVEN}
                                device={event.NUMEEQUI}
                                server={props.server}
                              />
                            </>
                          )}
                        </td>
                        <td>
                          <Tag>
                            {props.parkLookup[
                              props.server + "_" + event.NUMEPARC
                            ] || props.deviceLookup[event.NUMEPARC]}
                          </Tag>
                          <br />
                          <Tag>
                            {props.deviceLookup[
                              props.server + "_" + event.NUMEEQUI
                            ] || props.deviceLookup[event.NUMEEQUI]}
                          </Tag>
                        </td>
                        <td>
                          {event?.MONTSTAT > 0 && mefMontant(event.MONTSTAT)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </HTMLTable>
              </Callout>
            )}
          </>
        )}
      </Dialog>
    );
  else return null;
}
